var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPalestine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4_1583)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_4_1583)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-4.9815 39.7313C-4.95372 39.4905 -3.96298 38.722 3.7685 32.9257L12.4815 26.3887H43.7407H75V33.1942V39.9998H34.9907H-5.00928L-4.9815 39.7313Z",
    fill: "#009639"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.91673 7.00926C-3.10179 1.75926 -4.89809 0.37037 -4.89809 0.212963L-4.90735 0H35.0464H75.0001V6.80556V13.6111H43.8704H12.7315L3.91673 7.00926Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5927 26.5185C12.5927 26.3611 13.5649 25.5926 16.8519 23.1388C19.1852 21.3888 21.1019 19.9351 21.1019 19.9074C21.1019 19.8796 19.2315 18.4629 16.9445 16.7592C13.1204 13.9074 12.7871 13.6388 12.7778 13.3796C12.7778 13.1759 12.8056 13.1388 12.8889 13.2222C12.9723 13.3055 20.0093 13.3333 44.0001 13.3333H75.0001V20V26.6666L43.7964 26.6851L12.5927 26.7129V26.5185Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-5 20C-5 0.351852 -5 0 -4.82407 0C-4.72222 0 -4.62963 0.037037 -4.61111 0.0740741C-4.59259 0.111111 1.32407 4.57407 8.53704 9.98148C15.7593 15.3889 21.6667 19.8519 21.6667 19.9074C21.6667 19.963 15.7593 24.4259 8.5463 29.8241C1.32407 35.2315 -4.64815 39.7315 -4.74074 39.8241C-4.82407 39.9259 -4.91667 40 -4.94444 40C-4.97222 40 -5 31 -5 20Z",
    fill: "#ED2E38",
    stroke: "#FF0000",
    strokeWidth: 0.5
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4_1583"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_4_1583"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 40,
    fill: "white",
    transform: "translate(-5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPalestine);
export default __webpack_public_path__ + "static/media/palestine.7d78a5ba0a371e784be03dad209a177b.svg";
export { ForwardRef as ReactComponent };